import { ShopifyFieldIDSignal } from '..';

export const sortWithShopifyFieldIdSignal = (a: ShopifyFieldIDSignal, b: ShopifyFieldIDSignal) => {
  const aTime = a.___SIGNAL___ ?? new Date(1).getTime();
  const bTime = b.___SIGNAL___ ?? new Date(1).getTime();
  return aTime === bTime ? 0 : aTime > bTime ? 1 : -1;
};
